<div class="overflow-hidden h-full">
  <iframe
    [src]="url | safe" class="block w-full h-full border-0">
  </iframe>
</div>
